import { CircleAlertIcon } from 'lucide-react';
import { Alert } from '@shared/components';

export function ScheduledPaymentsNotice() {
    return (
        <Alert variant="warning" role="note" className="gap-2">
            <CircleAlertIcon className="size-4 shrink-0" aria-hidden="true" />
            Scheduled payment details are temporarily unavailable.
        </Alert>
    );
}
